import { GlLink, GlSprintf } from '@gitlab/ui';
import { s__ } from '~/locale';
import { TRACKING_ACTION_COPY_CONAN_COMMAND, TRACKING_ACTION_COPY_CONAN_SETUP_COMMAND, TRACKING_LABEL_CODE_INSTRUCTION, CONAN_HELP_PATH } from '~/packages_and_registries/package_registry/constants';
import CodeInstruction from '~/vue_shared/components/registry/code_instruction.vue';
export default {
    name: 'ConanInstallation',
    components: {
        CodeInstruction,
        GlLink,
        GlSprintf
    },
    props: {
        packageEntity: {
            type: Object,
            required: true
        }
    },
    computed: {
        conanInstallationCommand () {
            // eslint-disable-next-line @gitlab/require-i18n-strings
            return `conan install ${this.packageEntity.name} --remote=gitlab`;
        },
        conanSetupCommand () {
            // eslint-disable-next-line @gitlab/require-i18n-strings
            return `conan remote add gitlab ${this.packageEntity.conanUrl}`;
        }
    },
    i18n: {
        helpText: s__('PackageRegistry|For more information on the Conan registry, %{linkStart}see the documentation%{linkEnd}.')
    },
    tracking: {
        TRACKING_ACTION_COPY_CONAN_COMMAND,
        TRACKING_ACTION_COPY_CONAN_SETUP_COMMAND,
        TRACKING_LABEL_CODE_INSTRUCTION
    },
    links: {
        CONAN_HELP_PATH
    }
};
